import { createContext, useContext, useEffect, useState } from 'react';
import { defaultUserData } from '@shared/constants/userDefault';
import type { IUserData } from '@shared/types/user';

export const UserDataContext = createContext<[IUserData, boolean]>([defaultUserData, true]);

let _setData: (userData: IUserData) => void;

export const UserDataProvider = ({ children }: { children: React.ReactNode }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<IUserData>(defaultUserData);
  _setData = setData;

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch('/api/getUserData');
        const data = await response.json();
        // console.log(
        //   `%cdata from fetchUserData:`,
        //   'color: #221; background: #F40;padding: 2px 8px; font-weight: bold',
        //   data
        // );
        setData(data.userData as IUserData);
      } catch (error) {
        console.error('Error fetching user data in UserDataProvider:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchUserData();
  }, []);

  useEffect(() => {
    // @ts-expect-error - this is for debugging purposes.
    window.userData = data;
  }, [data]);

  return (
    <UserDataContext.Provider value={[data, isLoading] as const}>
      {children}
    </UserDataContext.Provider>
  );
};

export const useUserData = () => {
  const context = useContext(UserDataContext);
  if (!context) {
    throw new Error('useUserData must be used within a UserDataProvider');
  }
  return context;
};

export const setUserData = (userData: IUserData) => {
  _setData(userData);
};

export const unsetUserData = () => {
  _setData(defaultUserData);
};
